.details {
  border-top: 1px solid var(--rule);
  padding: 0.75rem 0;
}

.summary {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--ink-soft);
  cursor: pointer;
}

.summary:focus-visible {
  outline: 2px solid var(--cy-500);
  outline-offset: 2px;
}

.content {
  margin-top: 0.5rem;
}
